import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VideoDialogComponent } from 'app/core/components/video-dialog/video-dialog.component';
import { Exercise, ResourceType } from 'fitforce-document-sync';

@Injectable({
  providedIn: 'root'
})
export class DocumentResourceService {

  constructor(private dialog: MatDialog) { }

  getResource(exercise: Exercise, type: ResourceType) {
    return exercise
      ? exercise.resources
        ? exercise.resources.find(resource => resource.type && resource.type === type.toString())
        : null
      : null;
  }

  showResource(exercise: Exercise, type: ResourceType) {
    switch (type) {
      case ResourceType.Video:
          const video = this.getResource(exercise, type);
          if (video) {
            const dialog = this.dialog.open(VideoDialogComponent, {
              width: '700px',
              maxWidth: '700px',
              data: video,
            });
            dialog.afterClosed().subscribe();
          }
        break;
      case ResourceType.Audio:
      case ResourceType.Image:
      default:
        break;
    }
  }
}
